import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Voice, VoiceQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const VOICE_URL = `${API_URL}/invoice`
const GET_VOICE_URL = `${API_URL}/invoice`

const getVoices = (query: string): Promise<VoiceQueryResponse> => {
  return axios
    .get(`${GET_VOICE_URL}?${query}`)
    .then((d: AxiosResponse<VoiceQueryResponse>) => d.data)
}

const getVoicesArray = (): Promise<Array<Voice>> => {
  return axios.get(`${GET_VOICE_URL}`).then((d: AxiosResponse<any>) => {
    return d.data.data
  })
}

const getVoiceById = (id: ID): Promise<Voice | undefined> => {
  return axios
    .get(`${VOICE_URL}/${id}`)
    .then((response: AxiosResponse<Response<Voice>>) => response.data)
    .then((response: Response<Voice>) => response.data)
}

const createVoice = (voice: Voice): Promise<Voice | undefined> => {
  return axios
    .post(VOICE_URL, voice)
    .then((response: AxiosResponse<Response<Voice>>) => response.data)
    .then((response: Response<Voice>) => response.data)
}

const updateVoice = (voice: Voice): Promise<Voice | undefined> => {
  return axios
    .put(`${VOICE_URL}/${voice._id}`, voice)
    .then((response: AxiosResponse<Response<Voice>>) => response.data)
    .then((response: Response<Voice>) => response.data)
}

const deleteVoice = (voiceId: ID): Promise<void> => {
  return axios.delete(`${VOICE_URL}/${voiceId}`).then(() => {})
}

const deleteSelectedVoices = (voiceIds: Array<ID>): Promise<void> => {
  const requests = voiceIds.map((id) => axios.delete(`${VOICE_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

const downloadInvoice = (id: ID): Promise<Blob> => {
  return axios
    .get(`${VOICE_URL}/${id}/export`, {responseType: 'blob'})
    .then((res: AxiosResponse<Blob>) => res.data)
}

const sendInvoiceByEmail = (id: ID): Promise<any> => {
  return axios
    .get(`${VOICE_URL}/${id}/export?toEmail=true`)
    .then((res: AxiosResponse<any>) => res.data)
}

export {
  getVoices,
  getVoicesArray,
  deleteVoice,
  deleteSelectedVoices,
  getVoiceById,
  createVoice,
  updateVoice,
  downloadInvoice,
  sendInvoiceByEmail,
}
